import React from 'react'
import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@material-ui/core'
import { Text } from 'react-native'

type Props = {
  visible: boolean
  title: string
  message: React.ReactNode
  onClose: () => void
  confirmLabel?: string
}

export default function PolicyDispatchingDialog({ visible, title, message, onClose, confirmLabel = 'Đã hiểu' }: Props) {
  return (
    <Dialog open={visible} onClose={onClose} aria-labelledby="policy-dispatching-dialog-title" maxWidth="xs" fullWidth>
      <DialogTitle id="policy-dispatching-dialog-title" style={{ borderBottom: '1px solid #E8E3E3' }}>
        <strong>{title}</strong>
      </DialogTitle>
      <DialogContent style={{ padding: '16px 24px' }}>
        <Text style={styles.message}>{message}</Text>
      </DialogContent>
      <DialogActions style={{ padding: '16px 24px' }}>
        <Button variant="contained" color="primary" onClick={onClose}>
          {confirmLabel}
        </Button>
      </DialogActions>
    </Dialog>
  )
}

const styles: Record<string, any> = {
  message: {
    color: '#374151',
    fontSize: 15,
    lineHeight: 22,
    paddingTop: 4,
    paddingBottom: 8
  }
}
